
import { Link } from "react-router-dom";
import { Navigation } from "@/components/Navigation";
import { MobileNavigation } from "@/components/MobileNavigation";

interface PinDetailsErrorViewProps {
  error: string | null;
}

export function PinDetailsErrorView({ error }: PinDetailsErrorViewProps) {
  return (
    <div className="min-h-screen">
      <Navigation />
      <div className="container mx-auto px-4 pt-20 pb-16">
        <div className="text-center py-10">
          <h2 className="text-2xl font-bold">Pin não encontrado</h2>
          <p className="mt-2 text-muted-foreground">
            {error || "O pin que você está procurando não existe ou foi removido."}
          </p>
          <Link
            to="/"
            className="mt-4 inline-block px-4 py-2 bg-primary text-white rounded-md"
          >
            Voltar para a página inicial
          </Link>
        </div>
      </div>
      <MobileNavigation />
    </div>
  );
}
